export default defineNuxtRouteMiddleware((to) => {
  const appStore = useAppStore()

  appStore.$patch({
    devMode: to.query?.devMode === 'true'
  })
})
